import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { FolderStructure, SupplierDetails } from '../shared/models/documents.model';
import { DataSourceService } from './data-source.service';

@Injectable({
  providedIn: 'root'
})
export class ShareDataService {

  private isUndoClick = new BehaviorSubject<any>(false);
  private allSupplierData = new Subject<SupplierDetails[]>();
  public getAllSupplierData$ = this.allSupplierData.asObservable();
  private folderStructure = new BehaviorSubject<FolderStructure>(null);
  public getFolderStructure$ = this.folderStructure.asObservable();

  constructor(private dataSource:DataSourceService) { }

  setUndoButtonInfo(undoButtonStatus: boolean) {
    this.isUndoClick.next(undoButtonStatus);
  }
  getUndoButtonInfo() {
    return this.isUndoClick.asObservable();
  }

  emitAllSupplier(data: SupplierDetails[]){
    this.allSupplierData.next(data);
  }
  emitfolderStructure(data: FolderStructure){
    this.folderStructure.next(data);
  }
  getAllSuppliers(): Observable<SupplierDetails[]> {
    return this.dataSource.getAllSuppliers();
  }
  getSuppliersByUserId(cwsId: string): Observable<SupplierDetails[]> {
    return this.dataSource.getSuppliersByUserId(cwsId);
  }
}
